import { Stack } from "@mantine/core";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";
import { HeldEmailQueueBulkActions } from "./HeldEmailQueueBulkActions";
import { HeldEmailQueueFilters } from "./HeldEmailQueueFilters";
import { HeldEmailQueueResults } from "./HeldEmailQueueResults";
import { HeldEmailStatsCards } from "./HeldEmailStatsCards";

export function HeldEmailQueuePrimaryView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <Stack gap="md">
      {model.stats && <HeldEmailStatsCards stats={model.stats} />}
      <HeldEmailQueueFilters dispatch={model.dispatch} state={model.state} />
      <HeldEmailQueueBulkActions
        dispatch={model.dispatch}
        state={model.state}
      />
      <HeldEmailQueueResults model={model} />
    </Stack>
  );
}
